<template>
    <Modal :show="show" @close="close"
           :custom_modal_class="'fullwidth-modal music-library-modal'"
           :custom_dialog_css="'width:90vw; max-width: 1600px; max-height:80vh'"
           :custom_body_css="'padding-top: 0'">
        <div slot="header">
            <div class="modal-header music-library-header">
                <h5 class="modal-title">{{ $t('blocks.music_library_title') }}</h5>

                <button type="button" style="margin-left: 0" class="close" data-dismiss="modal"
                        aria-label="Close" @click="close"><span
                    aria-hidden="true">×</span></button>
            </div>
        </div>

        <div slot="body">
            <SongLibrary
                :song-url="songUrl"
                @song_added="songAdded"
            />
        </div>

        <div slot="footer">
            <button type="button" class="btn btn-secondary btn-sm d-none" data-dismiss="modal"
                    @click="close">
                {{ $t('general.close') }}
            </button>
            <button type="button" class="btn btn-secondary btn-sm d-sm-none">
                {{ $t('general.search') }}
            </button>
        </div>
    </Modal>
</template>

<script setup>
    import Modal from './Modal.vue';
    import SongLibrary from '../designer/components/SongLibrary.vue';
    import { ref } from 'vue';

    const emit = defineEmits(['close', 'song-added']);
    defineProps({
        songUrl: {
            type: String,
            required: true,
        },
    });

    // Default open
    const show = ref(true);

    function songAdded(song) {
        emit('song-added', song);
    }

    function close() {
        emit('close');
    }
</script>
